export default {"src":"/_next/static/media/ManyVids.1c53f11e.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};